import { TemplateData, TemplateParams } from '.';

const achievementIndividualRequestNew = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'achievements',
  email: {
    buttonEnabled: true,
    buttonLink: '{{individualAchievementsUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.achievementsIndividualRequestNewStartContent}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.achievementsIndividualNewRequest}`
  },
  placeholders: {
    achievementTitle: {
      label: messages.achievementTitle,
      example: 'Test achievement'
    },
    individualAchievementsUrl: {
      label: messages.individualAchievementsLink,
      value: `${serverConfig.adminUrl}/achievements/individual`
    },
    user: {
      label: messages.commonUser,
      example: 'Bob Smith'
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeAchievementIndividualRequestNew
});

export default achievementIndividualRequestNew;
